import type { Option } from "@/components/form-inputs/StackedLabelKeyValueDropdown.vue";

export enum CustomFieldNumericOption {
  CURRENCY = "C",
  PERCENT = "P",
  NUMBER = "N",
}

export const NumericFormatDropdownOptions: Option[] = [
  {
    display: "Number",
    value: CustomFieldNumericOption.NUMBER,
  },
  {
    display: "Currency",
    value: CustomFieldNumericOption.CURRENCY,
  },
  {
    display: "Percent",
    value: CustomFieldNumericOption.PERCENT,
  },
];
